import { render, staticRenderFns } from "./pdf-display.vue?vue&type=template&id=aafec380&scoped=true&"
import script from "./pdf-display.vue?vue&type=script&lang=ts&"
export * from "./pdf-display.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-display.vue?vue&type=style&index=0&id=aafec380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafec380",
  null
  
)

export default component.exports